

const About = () => {
  return (
    <div className="min-h-screen py-12">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold text-center text-gray-800 mb-12">About Our Institution</h1>
        
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-md p-8 mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Our History</h2>
            <p className="text-gray-600 mb-4">
              Established in 1990, our institution has been dedicated to providing quality education 
              and fostering academic excellence for over three decades. We began with just 50 students 
              and 5 faculty members, and have grown into a prestigious educational institution serving 
              thousands of students annually.
            </p>
            <p className="text-gray-600">
              Throughout our journey, we have maintained our commitment to holistic development, 
              academic rigor, and character building. Our alumni have gone on to become leaders in 
              various fields, contributing significantly to society.
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-md p-8 mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Our Mission</h2>
            <p className="text-gray-600">
              Our mission is to provide world-class education that empowers students to achieve their 
              full potential, develop critical thinking skills, and become responsible global citizens. 
              We strive to create an inclusive learning environment that celebrates diversity and promotes 
              innovation, creativity, and ethical values.
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-md p-8 mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Our Vision</h2>
            <p className="text-gray-600">
              To be a leading educational institution recognized globally for academic excellence, 
              research innovation, and the development of ethical leaders who contribute positively 
              to society. We envision creating a community of lifelong learners who adapt to changing 
              global dynamics while preserving cultural values and traditions.
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-md p-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Principal's Message</h2>
            <div className="flex items-start">
              <div className="mr-6">
                <div className="bg-gray-200 border-2 border-dashed rounded-xl w-32 h-32" />
              </div>
              <div>
                <p className="text-gray-600 italic mb-4">
                  "Education is not the filling of a vessel, but the kindling of a flame. At our institution, 
                  we ignite the spark of curiosity, critical thinking, and lifelong learning in every student. 
                  We believe in nurturing not just academic brilliance but also moral integrity and leadership qualities."
                </p>
                <p className="text-gray-800 font-semibold">Dr. Jane Smith</p>
                <p className="text-gray-600">Principal</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;